/**
 * conversions {
 *    category: {
 *       global: {
 *           option: 'datatype',
 *           ...
 *       },
 *       target: {
 *           option: 'datatype',
 *           ...
 *       },
 *       ...
 *    }
 * }
 */

import { pageNotification } from '../../qaamgo/helper/notify';
import { globalLogger } from '../../qaamgo/helper/global-logger';
import { translate } from '../../qaamgo/helper/translate';
import { INPUT_TYPE_FILE_UPLOAD } from '../uploader/core/consts';
import {
    testIsEmptyString,
    testIsNotUndefined,
    testIsNumber,
    testIsTrueish,
    testIsUndefined,
} from '../../lib/test-and-assert/test-base';
import { eventBus } from '../../lib/event-bus/event-bus';
import { NEW_COST_EVENT, HIDE_OPTIONS_EVENT, SHOW_OPTIONS_EVENT } from '../../lib-sat/uploader/core/event';
import { UploaderEvent } from '../uploader/core/event';

let groupedOptions = {
    image: {
        remove_background: ['alpha_channel'],
        image_options: [
            'deskew',
            'equalize',
            'normalize',
            'enhance',
            'sharpen',
            'antialias',
            'despeckle',
            'multilayer',
        ],
        crop: [
            'crop_top',
            'crop_bottom',
            'crop_left',
            'crop_right',
            'crop_width',
            'crop_height',
            'crop_origin_x',
            'crop_origin_y',
        ],
        resolution: ['width', 'height'],
        compress_advanced: ['compress', 'monochrome', 'downscale'],
        compress_basic: ['compress'],
    },
    video: {
        cut: ['start', 'end'],
        resolution: ['width', 'height'],
        crop: [
            'crop_top',
            'crop_bottom',
            'crop_left',
            'crop_right',
            'crop_width',
            'crop_height',
            'crop_origin_x',
            'crop_origin_y',
        ],
    },
    audio: {
        trim: ['start', 'end'],
    },
    document: {
        ocr_with_choice: ['ocr', 'ocr_mode', 'language', 'ocr_monochrome'],
        ocr_without_choice: ['ocr', 'ocr_mode', 'language', 'ocr_monochrome'],
        compression_and_quality: ['compression', 'quality'],
    },
};

var conversions = {
    document: {
        global: {
            allow_multiple_outputs: 'boolean',
        },
        doc: {
            ocr: 'boolean',
            language: 'string',
            ocr_mode: 'string',
            ocr_monochrome: 'boolean',
        },
        docx: {
            ocr: 'boolean',
            language: 'string',
            ocr_mode: 'string',
            ocr_monochrome: 'boolean',
        },
        html: {},
        odt: {
            ocr: 'boolean',
            language: 'string',
        },
        pdf: {
            images_quality: 'integer',
            dpi: 'integer',
            quality: 'string',
            color: 'string',
            page_size: 'string',
            custom_page_size_width: 'string',
            custom_page_size_height: 'string',
            custom_page_size_unit: 'string',
            rotate: 'array',
            rearrange: 'string',
            split: 'string',
            merge: 'boolean',
            stamp: 'boolean',
            watermark: 'boolean',
            grayscale: 'boolean',
            deskew: 'boolean',
            ocr: 'boolean',
            language: 'string',
            compression: 'string',
            linearize: 'boolean',
            version: 'string',
            new_owner_password: 'string',
            new_user_password: 'string',
            allow_printing: 'boolean',
            allow_copying: 'boolean',
            allow_modification: 'boolean',
            rasterize_dpi: 'integer',
            one_file_per_page: 'boolean',
            patch: 'object',
            ocr_filter: 'string',
            ocr_engine: 'string',
            filters: 'array',
            file_size: 'integer',
        },
        ppt: {},
        pptx: {},
        rtf: {
            ocr: 'boolean',
            ocr_mode: 'string',
            ocr_monochrome: 'boolean',
            language: 'string',
        },
        txt: {
            ocr: 'boolean',
            language: 'string',
            ocr_filter: 'string',
            ocr_engine: 'string',
        },
        xlsx: {
            ocr: 'boolean',
            ocr_monochrome: 'boolean',
            language: 'string',
        },
        xls: {
            ocr: 'boolean',
            language: 'string',
        },
    },
    video: {
        global: {
            allow_multiple_outputs: 'boolean',
        },
        mp4: {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            audio_bitrate: 'integer',
            audio_codec: 'string',
            codec: 'string',
            rotate: 'integer',
            start: 'string',
            end: 'string',
            mirror: 'string',
            file_size: 'integer',
            normalize: 'boolean',
            crf: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            resize_by: 'string',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            preset: 'string',
            audio_frequency: 'integer',
            audio_fade: 'array',
            loop_audio: 'boolean',
            keep_original_audio: 'boolean',
            input_filters: 'array',
        },
        avi: {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            codec: 'string',
            crf: 'integer',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            preset: 'string',
            audio_frequency: 'integer',
        },
        blackberry: {
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
        },
        dpg: {
            version: 'integer',
            remove_audio: 'boolean',
        },

        '3g2': {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            codec: 'string',
            crf: 'integer',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            audio_bitrate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            mirror: 'string',
            rotate: 'integer',
            audio_frequency: 'integer',
        },
        '3gp': {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            start: 'string',
            end: 'string',
            format: 'string',
            normalize: 'boolean',
            codec: 'string',
            crf: 'integer',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            mirror: 'string',
            audio_frequency: 'integer',
        },
        android: {
            video_bitrate: 'integer',
            start: 'string',
            end: 'string',
            audio_bitrate: 'integer',
            framerate: 'integer',
        },
        flv: {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            codec: 'string',
            crf: 'string',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        hls: {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            codec: 'string',
            crf: 'string',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
        },
        ipad: {
            video_bitrate: 'integer',
            framerate: 'integer',
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
            width: 'integer',
            height: 'integer',
        },
        iphone: {
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
        },
        ipod: {
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
        },
        mkv: {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            codec: 'string',
            crf: 'string',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        mov: {
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            codec: 'string',
            crf: 'string',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        webm: {
            preset: 'string',
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            audio_bitrate: 'integer',
            codec: 'string',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'arrays',
            mirror: 'string',
            rotate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        wii: {
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
        },
        wmv: {
            preset: 'string',
            video_bitrate: 'integer',
            remove_audio: 'boolean',
            framerate: 'float',
            width: 'integer',
            height: 'integer',
            start: 'string',
            end: 'string',
            normalize: 'boolean',
            audio_bitrate: 'integer',
            codec: 'string',
            audio_codec: 'string',
            channel: 'string',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            mirror: 'string',
            rotate: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        xbox: {
            preset: 'string',
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
        },
        'mpeg-1': {
            audio_codec: 'string',
            video_bitrate: 'integer',
            framerate: 'float',
            remove_audio: 'boolean',
            channel: 'string',
            normalize: 'boolean',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            width: 'integer',
            height: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        'mpeg-2': {
            audio_codec: 'string',
            video_bitrate: 'integer',
            framerate: 'float',
            remove_audio: 'boolean',
            channel: 'string',
            normalize: 'boolean',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            width: 'integer',
            height: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        mpg: {
            preset: 'string',
            codec: 'string',
            audio_codec: 'string',
            video_bitrate: 'integer',
            framerate: 'float',
            remove_audio: 'boolean',
            channel: 'string',
            normalize: 'boolean',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            width: 'integer',
            height: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        'nintendo-3ds': {
            start: 'string',
            end: 'string',
            mirror: 'string',
        },
        'nintendo-ds': {
            dpg: 'integer',
        },
        ogg: {
            video_bitrate: 'integer',
            framerate: 'float',
            remove_audio: 'boolean',
            channel: 'string',
            normalize: 'boolean',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            width: 'integer',
            height: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_frequency: 'integer',
        },
        ogv: {
            video_bitrate: 'integer',
            framerate: 'float',
            remove_audio: 'boolean',
            channel: 'string',
            normalize: 'boolean',
            deinterlace: 'boolean',
            aspect_ratio: 'string',
            overlays: 'array',
            start: 'string',
            end: 'string',
            mirror: 'string',
            rotate: 'integer',
            audio_bitrate: 'integer',
            width: 'integer',
            height: 'integer',
            resize_handling: 'string',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            audio_codec: 'string',
            audio_frequency: 'integer',
        },
        ps3: {
            video_bitrate: 'integer',
            framerate: 'integer',
            start: 'string',
            end: 'string',
            mirror: 'string',
        },
    },
    image: {
        global: {
            allow_multiple_outputs: 'boolean',
            dpi: 'integer',
            width: 'integer',
            height: 'integer',
            crop_top: 'integer',
            crop_bottom: 'integer',
            crop_left: 'integer',
            crop_right: 'integer',
            crop_origin_x: 'integer',
            crop_origin_y: 'integer',
            crop_width: 'integer',
            crop_height: 'integer',
            color: 'string',
            enhance: 'boolean',
            normalize: 'boolean',
            sharpen: 'boolean',
            antialias: 'boolean',
            despeckle: 'boolean',
            equalize: 'boolean',
            deskew: 'boolean',
            black_white_threshold: 'integer',
            rotate: 'integer',
            remove_scratches: 'boolean',
            blur_level: 'integer',
            blur_size: 'integer',
            aspect_ratio: 'string',
            resize_handling: 'string',
        },
        bmp: {
            alpha_channel: 'string',
            resolution_unit: 'string',
            resize_by: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
        },
        eps: {
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
        },
        exr: {
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
        },
        gif: {
            framerate: 'integer',
            compress: 'string',
            alpha_channel: 'string',
            preset: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
            iterations: 'integer',
        },
        ico: {
            alpha_channel: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
        },
        jpg: {
            quality: 'integer',
            compress: 'string',
            resolution_unit: 'string',
            resize_unit: 'string',
            resize_by: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
            sampling_factor: 'string',
            colorspace: 'string',
        },
        png: {
            quality: 'integer',
            resolution_unit: 'string',
            resize_unit: 'string',
            resize_by: 'string',
            alpha_channel: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
            colorspace: 'string',
        },
        svg: {
            speckles_threshold: 'integer',
            alpha_channel: 'string',
            svg_engine: 'string',
        },
        tga: {
            alpha_channel: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
            colorspace: 'string',
        },
        tiff: {
            bitdepth: 'integer',
            alpha_channel: 'string',
            multilayer: 'boolean',
            resolution_unit: 'string',
            resize_by: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
            colorspace: 'string',
        },
        tif: {
            bitdepth: 'integer',
            alpha_channel: 'string',
            multilayer: 'boolean',
            resolution_unit: 'string',
            resize_by: 'string',
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
            colorspace: 'string',
        },
        wbmp: {
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
        },
        webp: {
            colorize_model_name: 'string',
            colorize_render_factor: 'integer',
        },
        metadata: {
            json: {
                type: 'string',
                keys_format: 'string',
                output_mode: 'string',
            },
        },
    },
    ebook: {
        global: {
            allow_multiple_outputs: 'boolean',
            reader: 'string',
            title: 'string',
            author: 'string',
            border: 'integer',
            encoding: 'string',
            ascii: 'boolean',
        },
        epub: {
            enable_heuristics: 'boolean',
            embed_font: 'string',
            base_font_size: 'integer',
            version: 'string',
        },
        azw3: {
            enable_heuristics: 'boolean',
            embed_font: 'string',
            base_font_size: 'integer',
        },
        fb2: {
            enable_heuristics: 'boolean',
            base_font_size: 'integer',
        },
        lit: {
            enable_heuristics: 'boolean',
            base_font_size: 'integer',
        },
        lrf: {
            enable_heuristics: 'boolean',
            base_font_size: 'integer',
        },
        mobi: {
            enable_heuristics: 'boolean',
            base_font_size: 'integer',
        },
        pdb: {
            enable_heuristics: 'boolean',
            base_font_size: 'integer',
        },
        pdf: {
            enable_heuristics: 'boolean',
            embed_font: 'string',
            base_font_size: 'integer',
            ocr: 'boolean',
            language: 'string',
        },
        'pdf-ebook': {
            embed_font: 'string',
        },
        tcr: {
            enable_heuristics: 'boolean',
            base_font_size: 'integer',
        },
    },
    audio: {
        global: {
            allow_multiple_outputs: 'boolean',
            frequency: 'integer',
            normalize: 'boolean',
            start: 'string',
            end: 'string',
            volume: 'string',
        },
        aac: {
            channels: 'string',
            audio_bitrate: 'integer',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        aiff: {
            channels: 'string',
            audio_bitrate: 'integer',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        flac: {
            channels: 'string',
            audio_bitdepth: 'integer',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        m4a: {
            audio_codec: 'string',
            audio_bitrate: 'integer',
            channels: 'string',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        m4r: {
            audio_codec: 'string',
            channels: 'string',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        mmf: {
            audio_bitrate: 'integer',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        mp3: {
            audio_bitrate: 'integer',
            audio_vbr: 'integer',
            channels: 'string',
            remove_coverart: 'boolean',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        ogg: {
            audio_codec: 'string',
            audio_bitrate: 'integer',
            normalize: 'boolean',
            audio_vbr: 'integer',
            channels: 'string',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        opus: {
            audio_bitrate: 'integer',
            channels: 'string',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        wav: {
            pcm_format: 'string',
            audio_bitdepth: 'integer',
            channels: 'string',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
        wma: {
            audio_bitrate: 'integer',
            audio_codec: 'string',
            channels: 'string',
            normalize_type: 'string',
            normalize_target_level: 'integer',
            normalize_target_level_ebu: 'integer',
            normalize_loudness_range_target_ebu: 'integer',
            normalize_true_peak_ebu: 'integer',
        },
    },
    cad: {
        global: {
            allow_multiple_outputs: 'boolean',
        },
        dwg: {
            version: 'string',
        },
        dxf: {
            version: 'string',
        },
    },
    hash: {
        global: {
            allow_multiple_outputs: 'boolean',
        },
        adler32: {
            hmac: 'string',
        },
        'apache-htpasswd': {
            salt: 'string',
        },
        blowfish: {
            rounds: 'integer',
            salt: 'string',
        },
        crc32: {
            hmac: 'string',
        },
        crc32b: {
            hmac: 'string',
        },
        gost: {
            hmac: 'string',
        },
        haval128: {
            rounds: 'integer',
            hmac: 'string',
        },
        md4: {
            hmac: 'string',
        },
        md5: {
            hmac: 'string',
        },
        ripemd128: {
            hmac: 'string',
        },
        ripemd160: {
            hmac: 'string',
        },
        sha1: {
            hmac: 'string',
        },
        sha256: {
            hmac: 'string',
        },
        sha384: {
            hmac: 'string',
        },
        sha512: {
            hmac: 'string',
        },
        snefru: {
            hmac: 'string',
        },
        'std-des': {
            salt: 'string',
        },
        tiger128: {
            rounds: 'integer',
            hmac: 'string',
        },
        'tiger128-calculator': {},
        'tiger128-converter': {},
        tiger160: {
            rounds: 'integer',
            hmac: 'string',
        },
        tiger192: {
            rounds: 'integer',
            hmac: 'string',
        },
        whirlpool: {
            hmac: 'string',
        },
    },
    operation: {
        global: {
            allow_multiple_outputs: 'boolean',
            max_outputs_per_input: 'integer',
        },
        compress: {
            compression_level: 'string',
            compression_target: 'string',
        },
        'validate-pdfa': {
            validation_profile: 'string',
        },
        ai_upscale: {
            upscale_factor: 'string',
            width: 'integer',
            height: 'integer',
            target_format: 'string',
            model: 'string',
            resize_unit: 'string',
        },
        'ai-ocr': {
            language: 'string',
            target_format: 'string',
            illuminate: 'boolean',
            unwrap: 'boolean',
            ocr_engine: 'string',
            ocr_engine_options: 'object',
        },
        'remove-background': {
            function: 'string',
            model: 'string',
        },
        compare_image: {
            diff_color: 'string',
            threshold: 'integer',
            method: 'string',
        },
        speech_to_text: {
            language_stt: 'string',
            target_format: 'string',
            model: 'string',
        },
        text_to_image: {
            style: 'string',
            width: 'int',
            height: 'int',
            num_interference_steps: 'int',
            prompt: 'string',
            negative_prompt: 'string',
        },
        'extract-streams': {
            stream: 'string',
        },
        'text-to-speech': {
            tts_audio_format: 'string',
            language: 'string',
            gender: 'string',
        },
    },
    device: {
        global: {},
        blackberry: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        android: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        ipad: {
            preset: 'string',
            remove_audio: 'string',
            cut: 'string',
        },
        iphone: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        ipod: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        wii: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        xbox: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        '3ds': {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        'nintendo-ds': {
            preset: 'string',
            dpg: 'integer',
        },
        ps3: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
        dpg: {
            version: 'string',
            remove_audio: 'boolean',
        },
        psp: {
            preset: 'string',
            remove_audio: 'boolean',
            cut: 'string',
        },
    },
    metadata: {
        json: {
            type: 'string',
            keys_format: 'string',
            output_mode: 'string',
        },
    },
};

var errorMessages = {};

/**
 *
 * @param {String} value
 * @param inputField
 */
function isTimestampValid(value, inputField) {
    var id = inputField.attr('id');
    setTimestampErrorMessage(id);
    return value.match('^[0-9]{2}:[0-9]{2}:[0-9]{2}$');
}

/**
 *
 * @param {int} value
 * @param inputField
 * @param target
 * @returns {boolean}
 */
function isNumberValueValid(value, inputField, target) {
    var max = inputField.attr('max');
    var min = inputField.attr('min');

    max = parseInt(max);
    min = parseInt(min);

    if (value >= min && value <= max) {
        return true;
    } else {
        var id = inputField.attr('id');
        setErrorMessage(min, max, id);
        return false;
    }
}

function isAspectRatioValid(value, inputField) {
    var id = inputField.attr('id');
    setAspectRatioErrorMessage(id);
    return value.match('^[0-9]{1,6}:[0-9]{1,6}$');
}

/**
 *
 * @param {int}min
 * @param {int}max
 * @param {String}id
 */
function setErrorMessage(min, max, id) {
    var message = 'Enter a value between %min% and %max%';
    message = translate(message);
    message = message.replace('%min%', min);
    message = message.replace('%max%', max);
    errorMessages[id] = message;
}

/**
 *
 * @param id
 */
function setTimestampErrorMessage(id) {
    var message = 'Enter timestamp in this format: 00:00:00';
    message = translate(message);
    errorMessages[id] = message;
}

/**
 *
 * @param id
 */
function setAspectRatioErrorMessage(id) {
    var message = 'Invalid aspect ratio';
    message = translate(message);
    errorMessages[id] = message;
}

/**ocr_mode
 *
 * @param inputField
 * @param value
 * @param {String}validationMethod
 * @param target
 * @returns {RegExpMatchArray|boolean}
 */
function validateInputField(inputField, value, validationMethod, target) {
    if (validationMethod === 'timestamp') {
        return isTimestampValid(value, inputField);
    } else if (validationMethod === 'number_range') {
        return isNumberValueValid(value, inputField, target);
    } else if (validationMethod === 'aspect_ratio') {
        return isAspectRatioValid(value, inputField);
    } else {
        globalLogger.log('validation method not specified');
        return false;
    }
}

/**
 *
 * @param {Object} inputField
 */
function removeHighlight(inputField) {
    if (inputField.attr('id') === 'inputLanguage') {
        $('#MultipleLanguages .multiselect__tags').css('border-color', '');
        let input_warning = $('#MultipleLanguages .input-warning');
        input_warning.addClass('hidden');
    }

    inputField.css('border-color', '');
    var input_group_addon = inputField.next('.input-group-addon');
    var input_warning = input_group_addon.next('.input-warning');
    var invalid_message = $('.invalid-message');

    invalid_message.addClass('hidden');
    input_warning.addClass('hidden');

    if (input_group_addon.length === 0) {
        inputField.next('.input-warning').addClass('hidden');
    }
}

/**
 *
 * @param {Array}invalidFields
 */
function highlightInvalidFields(invalidFields) {
    for (var i = 0; i < invalidFields.length; i++) {
        if (invalidFields[i].attr('id') === 'inputLanguage') {
            let message = 'You have to select at least one language for OCR to work properly';
            $('#MultipleLanguages .multiselect__tags').css('border-color', '#dd4b39');
            let invalid_message = $('#MultipleLanguages .invalid-message');
            invalid_message.text(translate(message));
            invalid_message.removeClass('hidden');
            continue;
        }

        invalidFields[i].css('border-color', '#dd4b39');

        var input_group_addon = invalidFields[i].next('.input-group-addon');
        var input_warning = input_group_addon.next('.input-warning');
        var id = invalidFields[i].attr('id');
        var message = '';

        if (errorMessages.hasOwnProperty(id)) {
            message = errorMessages[id];
        }

        if (input_warning.length === 0) {
            invalidFields[i].next('.input-warning').after('<div class="invalid-message">' + message + '</div>');
            // invalidFields[i].next('.input-warning').removeClass('hidden');
        } else {
            input_warning.after('<div class="invalid-message">' + message + '</div>');
            // input_warning.removeClass('hidden');
        }
    }
}

/**
 *
 * @param {Object} conversionOptions
 * @returns {Array}
 */
var getInvalidFields = function (conversionOptions) {
    var target = conversionOptions['target'].toString();
    var invalidFields = [];

    for (var id in conversionOptions) {
        if (conversionOptions.hasOwnProperty(id)) {
            var inputField = $('#' + id);

            removeHighlight(inputField);

            if (inputField.attr('type') === 'number' || inputField.attr('type') === 'text') {
                var validationMethod = inputField.attr('data-validation-method');
                var value = conversionOptions[id]['value'];

                if (
                    value !== '' &&
                    inputField.data('option-ignore') !== true &&
                    typeof validationMethod !== 'undefined'
                ) {
                    if (!validateInputField(inputField, value, validationMethod, target)) {
                        invalidFields.push(inputField);
                    }
                }
            }
        }

        if (id === 'inputLanguage') {
            const amountOfSelectedLanguages = $('#inputLanguage').data('amount-languages');

            if (
                (testIsUndefined(amountOfSelectedLanguages) || amountOfSelectedLanguages === 0) &&
                $('#ocr_enabled').is(':checked')
            ) {
                invalidFields.push(inputField);
            }
        }

        //Hotfix for failing resize PDF conversions
        //if custom page size radio is checked,
        //then width or height need to be specified
        if (id === 'page_size_unit') {
            if (
                testIsEmptyString($('#inputCustomPageWidth').val()) &&
                testIsEmptyString($('#inputCustomPageHeight').val())
            ) {
                invalidFields.push($('#inputCustomPageWidth'));
                invalidFields.push($('#inputCustomPageHeight'));
                setErrorMessage(
                    $('#inputCustomPageWidth').attr('min'),
                    $('#inputCustomPageWidth').attr('max'),
                    'inputCustomPageWidth'
                );

                setErrorMessage(
                    $('#inputCustomPageHeight').attr('min'),
                    $('#inputCustomPageHeight').attr('max'),
                    'inputCustomPageHeight'
                );

                pageNotification.warning('Please enter the desired width and height of your PDF!');
            }
        }
    }

    return invalidFields;
};

var showRelevantOptionsForTarget = function (category, target, uploader) {
    if (!conversions.hasOwnProperty(category)) {
        return false;
    }

    if (!conversions[category].hasOwnProperty(target)) {
        return false;
    }

    var $fields = $('#sendform').find('input, select');

    if (target === 'ico') {
        $('#inputWidth').attr('max', 256);
        $('#inputHeight').attr('max', 256);
    } else if (target === 'gif') {
        $('#inputWidth').attr('max', 3000);
        $('#inputHeight').attr('max', 3000);
    } else if (category === 'image') {
        $('#inputWidth').attr('max', 200000);
        $('#inputHeight').attr('max', 200000);
    } else if (category === 'video') {
        $('#inputWidth').attr('max', 10000);
        $('#inputHeight').attr('max', 10000);
    } else if (category === 'operation' && target === 'ai_upscale') {
        $('#inputWidth').attr('max', 12000);
        $('#inputHeight').attr('max', 12000);
    }

    if (target === 'tiger128' || target === 'tiger160' || target === 'tiger192') {
        $('#inputRounds').attr('min', 3);
        $('#inputRounds').attr('max', 4);
    }

    if (target === 'svg') {
        $('#inputBlackWhiteThreshold').attr('max', 100);
    } else {
        $('#inputBlackWhiteThreshold').attr('max', 255);
    }

    if (conversions[category][target].hasOwnProperty('preset')) {
        import(
            /* webpackMode: "lazy" */
            '../../qaamgo/modules/sat/global-presets'
        ).then(function () {});
    }

    updatePlaceholders();

    $('#inputHeight').on('blur', () => {
        updatePlaceholders();
    });

    $('#inputWidth').on('blur', () => {
        updatePlaceholders();
    });

    if (!conversions[category][target].hasOwnProperty('ocr_mode')) {
        $('.ocr_mode_selection').hide();
    } else {
        $('.ocr_mode_selection').show();
    }

    if (!conversions[category][target].hasOwnProperty('ocr') && target !== 'ai-ocr') {
        $('#MultipleLanguages').addClass('hidden');
    } else {
        $('#MultipleLanguages').removeClass('hidden');
    }

    $.each($fields, function (key, value) {
        var $e = $(value);
        var optName = $e.prop('name');
        var optType = $e.data('options-type');
        var $formGroup = $e.parents('.form-group');
        var $optionalSettingsPanel = $e.parents('.optional-settings-panel, .optional-settings');
        var optCategory = $e.data('category');
        var optIgnore = $e.data('option-ignore');

        //This is for our custom selectors like in _page_size.html.twig, since we have some radios there that are for switching between
        //custom page sizes and presets
        if (testIsTrueish(optIgnore)) {
            return;
        }

        if (optType !== 'options') {
            return;
        }

        // this code handles the case where the user can manually select a conversion target
        // after the user selected a target, the code below checks all options if they exists for that specific target
        // and then shows/hides those options and if necessary the settings panels, if there are no options inside it
        const optionsDoesNotExistForSelectedTarget =
            !conversions[category][target].hasOwnProperty(optName) &&
            !conversions[category]['global'].hasOwnProperty(optName);

        //This if for pages like Convert From PDF, where we have multiple targets with different categories.
        //If there's an option that exists for multiple targets, but with different values (e.g. "version" for pdf and dwg), this makes sure,
        //that the input with incorrect values is hidden
        const inputAndTargetcategoriesNotMatching = optCategory !== category && typeof optCategory !== 'undefined';

        if (optionsDoesNotExistForSelectedTarget || inputAndTargetcategoriesNotMatching) {
            //if the option for the specific target does not exist, we set data-option-ignore-for-target true so it won't get sent to the satcore/api
            // and also hide it
            $e.data('option-ignore-for-target', true).hide();
            $e.parent('label').hide();

            if ($formGroup.find('input, select').is(':visible') === false) {
                $formGroup.hide();
            }

            if ($('.ocr-filter-selection.form-group').find('input, select').is(':visible') === false) {
                $('.ocr-filter-selection.form-group').hide();
            }

            if ($optionalSettingsPanel.find('input, select').is(':visible') === false) {
                $optionalSettingsPanel.hide();
            }

            return;
        }

        $('input[name=category]').attr('value', category);

        if (!conversions[category][target].hasOwnProperty('ocr_mode')) {
            $('.ocr_mode_selection').hide();
        } else {
            $('.ocr_mode_selection').show();
        }

        if (!conversions[category][target].hasOwnProperty('ocr') && target !== 'ai-ocr') {
            $('#MultipleLanguages').addClass('hidden');
            $('#MultipleLanguages').css('display', 'none');
        }

        $formGroup.show();
        $optionalSettingsPanel.show();
        $e.parent('label').show();
        $e.data('option-ignore-for-target', false).show();
    });

    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
        placement: 'right',
        sanitizeFn: function (content) {
            return content;
        },
    });

    if (typeof uploader === 'undefined') {
        return;
    }

    if (target === 'png') {
        $('.png-quality-panel').removeClass('hidden');
        $('#pngQualityPreset').data('option-ignore', false);
        $('#pngQualityPreset').data('option-ignore-for-target', false);
        $('#pngQualityPreset').hide();
        $('#pngQualityRadio').prop('checked', true);
    } else {
        $('.png-quality-panel').addClass('hidden');
        $('#pngQualityPreset').data('option-ignore', true);
        $('#pngQualityPreset').data('option-ignore-for-target', true);
        $('#pngQualityPreset').hide();
        $('#compress_basic').prop('checked', true);
    }
    if (target === 'png' || target === 'jpg' || target === 'tga' || target === 'tif' || target === 'tiff') {
        $('#colorspace-option').removeClass('hidden');
    } else {
        $('#colorspace-option').addClass('hidden');
    }
};

/**
 * This function parses all input/select elements of a form and tries to create an object which
 * contains valid conversion options
 *
 * Each input MUST be annotated in one of two ways:
 *
 * 1) $e.data('option-ignore') is set to 'true'. In this case the element is skipped
 * 2) $e has options-type and all the other "tags". In this case it is used to create the
 *    conversion options
 *
 * If option-ignore is not set to true _and_ the "tags" are missing then this is considered a bug
 * and it needs investigating/fixing
 *
 * @param {String} formId
 * @param {Uploader} uploader
 *
 * @returns {Object}
 */
var getConversionOptionsFromForm = function (formId, uploader) {
    var $form = $(formId);

    if ($form.length === 0) {
        globalLogger.log('field validation fail could not find form', JSON.stringify(formId));
    }

    var data = {};

    var $fields = $form.find('input, select');

    $.each($fields, function (key, value) {
        var $e = $(value);

        // If an input element has options-ignore set to true then it is skipped
        var optIgnore = $e.data('option-ignore');
        var optIgnoreForTarget = $e.data('option-ignore-for-target');

        if (testIsTrueish(optIgnore)) {
            return;
        }

        if (testIsTrueish(optIgnoreForTarget)) {
            return;
        }

        var inputType = $e.prop('type');
        var optName = $e.prop('name');
        var optType = $e.data('options-type');
        var optInverse = $e.data('options-inverse');
        var optValueType = $e.data('value-type');
        var optIgnoreFalse = $e.data('option-ignore-false');
        var optValue = $e.val();
        var optValueString = $e.data('value');

        // if option-ignore is not set to true then this field must be set!
        if (typeof optType === 'undefined') {
            // this is our vue-based OCR selector which does not have any options-* data
            if ($e.hasClass('multiselect__input')) {
                return;
            }

            globalLogger.log('field validation - skipping input because of missing type', JSON.stringify({
                optName: optName,
            }));

            return;
        }

        if ($e.data('parent-radio-id') !== undefined) {
            var $radioElement = $('#' + $e.data('parent-radio-id'));

            if ($radioElement.is(':checked') === false) {
                return;
            }
        }

        if (optValue === '' || optValue === null) {
            return;
        }

        if (optValueType === 'boolean') {
            optValue = optValue === 'true' || optValue === true;
        }

        if (inputType === 'checkbox') {
            optValue = $e.is(':checked');
            if (optInverse === true) {
                optValue = !optValue;
            }

            if (optValue === false && optIgnoreFalse === true) {
                return;
            }
        }

        if (inputType === 'checkbox' && optValueType === 'integer') {
            if ($e.is(':checked') === true) {
                optValue = $e.val();
            }
        }

        if (inputType === 'checkbox' && optValueType === 'string') {
            if ($e.is(':checked') === true) {
                optValue = $e.data('value');
            }
        }

        if (inputType === 'radio') {
            optValue = $e.is(':checked');
            if (optInverse === true) {
                optValue = !optValue;
            }

            if (optValueType === 'string') {
                if (optValueString === 'ignore') {
                    return;
                }

                if ($e.is(':checked')) {
                    optValue = optValueString;
                } else {
                    return;
                }
            }

            if (optValueType === 'integer') {
                optValue = $e.data('value');
            }

            if (optValueType === 'float') {
                optValue = $e.val();
            }
        }

        if (optValueType === 'integer') {
            optValue = parseInt(optValue);
        }

        if (optValueType === 'float') {
            optValue = parseFloat(optValue);
        }

        if (optValueType === 'string') {
            optValue = optValue?.toString();
        }

        if (optType === 'base') {
            data[optName] = optValue;
            return;
        }

        // ignore option if the input field is a select-dropdown and the value is 'null'
        if (inputType === 'select-one' && optValue === 'null') {
            return;
        }

        if (!data.hasOwnProperty(optType)) {
            data[optType] = {};
        }

        //TODO This is a hack until we implement a real scale option in the conversion server
        if (optName === 'scale') {
            if (!testIsNumber(optValue)) {
                return;
            }

            try {
                /** @type {InputList} */
                var inputList = uploader.getInputList();

                var inputsInApi = inputList.getInputsInApi();

                /** @type {?ApiInput} */
                let input = inputsInApi[0];

                //We can only get metadata for file uploads
                if (input !== null && input.getType() === INPUT_TYPE_FILE_UPLOAD) {
                    const metadata = input.getMetadata();

                    if (metadata !== null) {
                        if (testIsNumber(metadata.image_width)) {
                            data['options']['width'] = Math.round(input.getMetadata().image_width * optValue);
                        }
                        if (testIsNumber(metadata.image_height)) {
                            data['options']['height'] = Math.round(input.getMetadata().image_height * optValue);
                        }
                    }
                }
            } catch (e) {}

            return;
        }

        //TODO This is a hack until we implement a proper way to send filter options
        if (optName === 'filters') {
            if (data['options']['filters']) {
                data['options']['filters'] = [...data['options']['filters'], { filter_name: optValue }];
            } else {
                data['options']['filters'] = [{ filter_name: optValue }];
            }
            return;
        }

        if (optName === 'audio_fade') {
            if (data['options']['audio_fade']) {
                data['options']['audio_fade'] = [...data['options']['audio_fade'], { type: optValue, duration: 2000 }];
            } else {
                data['options']['audio_fade'] = [{ type: optValue, duration: 2000 }];
            }
            return;
        }

        data[optType][optName] = optValue;
    });

    if (data.hasOwnProperty('undefined')) {
        globalLogger.log('field validation - found undefined', JSON.stringify(data));
    }
    return data;
};

/**
 * Under normal circumstances this should return an object with all the conversion
 * options which must be checked for a feature page.
 *
 * NOTE: For some rare corner-case-errors it already shows an error message and returns
 * false. This is not a clean and pure implementation but it makes the implementation
 * easier
 *
 * If you add more error handling here which returns `false`: please make sure that you
 * also show an error message to user (if necessary)
 *
 * @param formId
 * @returns {Object|Boolean}
 */
var getConversionOptionsForValidation = function (formId) {
    var data = {};

    var $form = $(formId);

    var $fields = $form.find('input, select');

    var startPoint = $('#inputStart').val();
    var endPoint = $('#inputEnd').val();

    if (typeof pageConfig !== 'undefined') {
        if (pageConfig.operation === 'cut' || pageConfig.operation === 'trim') {
            if (startPoint === '' && endPoint === '') {
                const startElement = document.getElementById('inputStart');

                $('.invalid-message').removeClass('hidden');
                startElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
                
                return false;
            }
        }

        if (pageConfig.operation === 'resize') {
            const scalePxRadio = document.getElementById('scalePx');

            if (scalePxRadio && scalePxRadio.checked) {
                if (!$('#inputWidth').val() && !$('#inputheight').val() && !$('#inputDpi').val()) {   
                    const inputElement = document.getElementById('inputWidth');

                    $('.invalid-message').removeClass('hidden');
                    inputElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
                    
                    return false;
                }
            }
            
        }
    }

    if (startPoint === '') {
        $('#inputStart').data('option-ignore', true);
        $('#inputStart').attr('data-option-ignore', true);
    }

    if (endPoint === '') {
        $('#inputEnd').data('option-ignore', true);
        $('#inputEnd').attr('data-option-ignore', true);
    }

    var conversionOptions = {};

    $.each($fields, function (key, value) {
        var $e = $(value);
        var optValue = $e.val();
        var optName = $e.prop('name');

        data[optName] = [optValue];

        if ($e.data('parent-radio-id') !== undefined) {
            var $radioElement = $('#' + $e.data('parent-radio-id'));

            if ($radioElement.is(':checked') === false) {
                return;
            }
        }

        if (optName === 'language' || !$(value).hasClass('hidden')) {
            var id = $(value).attr('id');
            var optionValue = $(value).val();

            if (id !== 'undefined' && value !== 'undefined' && optionValue !== 'undefined') {
                conversionOptions[id] = {};
                conversionOptions[id]['value'] = optionValue;
            }
        }
    });

    conversionOptions['target'] = data['target'];

    return conversionOptions;
};

/**
 *
 * @param formId
 * @returns {boolean}
 */
var isConversionOptionsFormValid = function (formId) {
    var conversionOptions = getConversionOptionsForValidation(formId);

    if (conversionOptions === false) {
        return false;
    }

    var invalidFields = getInvalidFields(conversionOptions);

    if (invalidFields.length > 0) {
        let id = invalidFields[0][0].id;
        let doc = document.getElementById(id);
        if (doc) {
            doc.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        pageNotification.error(translate('Please fix the errors below!'));
        highlightInvalidFields(invalidFields);
        globalLogger.log('Field validation failed');

        return false;
    } else {
        return true;
    }
};

let hideOptions = () => {
    $('#sendform').slideUp(400, function() {
        $(this).addClass('d-none');
    });
};

let showOptions = () => {
    $('#sendform').removeClass('d-none').slideDown(400, function() {
        $(this).removeClass('d-none'); // avoid the race condition here on start without files
    });
};

eventBus.listen(HIDE_OPTIONS_EVENT, () => {
    hideOptions();
});

eventBus.listen(SHOW_OPTIONS_EVENT, () => {
    showOptions();
});

var setupTargetDropDown = function (uploader) {
    $(document).on('click', '.radio-toggle', function () {
        var dataName = $(this).attr('data-name');
        var target = $(this).find("input[name='" + dataName + "']");
        
        target.prop('checked', true);
    });

    $(document).on('change', 'select[name="target"]', function () {
        var $e = $(this).find(':selected');
        var target = $e.val();

        var category = '';
        if ($e.is('[data-category]')) {
            category = $e.attr('data-category');
        } else {
            category = $('[name="category"]').val();
        }
        showRelevantOptionsForTarget(category, target, uploader);
    });

    setupTargetAndOptionToggle(uploader);
};

var setTargetCostTriggers = function () {
    $('#inputTarget').on('change', updateTargetCost).trigger('change');
};

var setupTargetAndOptionToggle = function (uploader) {
    $(document).on('click', '.radio-toggle-target-option', function () {
        var dataName = $(this).attr('data-name');
        var target = $(this).find("input[data-name='" + dataName + "']");
        target.prop('checked', true);

        const dataCategory = target.data('category');
        const dataTarget = target.data('target');
        const cost = target.data('cost');

        if (testIsNotUndefined(dataCategory && testIsNotUndefined(dataTarget))) {
            $('input[name=target]').attr('value', dataTarget);
            showRelevantOptionsForTarget(dataCategory, dataTarget, uploader);
            updateTargetCost(dataTarget, cost);
        }

        const dataOptionKey = target.data('option-key');
        const dataOptionValue = target.data('option-value');

        $('input[name="' + dataOptionKey + '"]').val(dataOptionValue);
    });
};

var updateTargetCost = function (newTarget, newCost) {
    window.pageConfig.target = newTarget;

    if (newCost !== undefined) {
        window.pageConfig.currentCost = newCost;

        const uploaderEvent = new UploaderEvent(NEW_COST_EVENT);

        uploaderEvent.data = { target: newTarget, cost: newCost };
        eventBus.emit(NEW_COST_EVENT, uploaderEvent);
    }
};

/**
 * This updates the conversion options based on the selected target
 */
var updateOptionsForDropDown = function (uploader) {
    var $selected = $('#inputTarget :selected');

    if ($selected.length === 0) {
        return;
    }

    var target = $selected.val();

    var category = '';

    if ($selected.is('[data-category]')) {
        category = $selected.attr('data-category');
    } else {
        category = $('[name="category"]').val();
    }

    showRelevantOptionsForTarget(category, target, uploader);
};

function updatePlaceholders() {
    $('#inputWidth').attr('placeholder', $('#inputWidth').attr('min') + ' - ' + $('#inputWidth').attr('max'));
    $('#inputHeight').attr('placeholder', $('#inputHeight').attr('min') + ' - ' + $('#inputHeight').attr('max'));
}

function highlightRadioButtons() {
    const allInputs = Array.prototype.slice.call(document.getElementsByTagName('input'), 0);
    const radioPanels = Array.prototype.slice.call(document.getElementsByClassName('radio-toggle'), 0);
    const inputsAndRadioPanels = allInputs.concat(radioPanels);

    //add click listener to radio and surrounding panels
    for (const input of inputsAndRadioPanels) {
        input.addEventListener('click', () => {
            highlight(inputsAndRadioPanels);
        });
    }

    highlight(inputsAndRadioPanels);
}

function highlight(inputsAndRadioPanels) {
    for (const element of inputsAndRadioPanels) {
        //find surrounding panel of radio button
        const panel = element.closest('.radio-toggle');
        if (panel) {
            panel.classList.remove('radio-panel-selected');
        }

        //if element is a radio that is checked and has a surrounding panel, highlight that panel
        if (element.type === 'radio' && element.checked && panel) {
            if (!panel.classList.contains('no-highlight')) {
                panel.classList.add('radio-panel-selected');
            }
        }

        //loop over all radios and panels to find the currently selected radio for highlighting
        for (const input of inputsAndRadioPanels) {
            if (input.classList.contains('radio-toggle')) {
                const actualRadio = input.querySelector('[type=radio]');

                //wait before code to check radio from click on surrounding panel is executed
                setTimeout(() => {
                    if (actualRadio?.checked) {
                        if (!input.classList.contains('no-highlight')) {
                            input.classList.add('radio-panel-selected');
                        }
                    }
                }, 5);
            }
        }
    }
}

var conversionOptions = {
    showRelevantOptionsForTarget: showRelevantOptionsForTarget,
    getConversionOptionsFromForm: getConversionOptionsFromForm,
    isConversionOptionsFormValid: isConversionOptionsFormValid,
    setupTargetDropDown: setupTargetDropDown,
    updateOptionsForDropDown: updateOptionsForDropDown,
    highlightRadioButtons: highlightRadioButtons,
};

export { conversionOptions };
export { conversions };
export { groupedOptions };
